import { render, staticRenderFns } from "./AddGames.vue?vue&type=template&id=d7bb5282&scoped=true&"
import script from "./AddGames.vue?vue&type=script&lang=js&"
export * from "./AddGames.vue?vue&type=script&lang=js&"
import style0 from "./AddGames.vue?vue&type=style&index=0&id=d7bb5282&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bb5282",
  null
  
)

export default component.exports